import { getDayOfWeek, stringToDate } from '@shared/utils/date';
import { PERIOD_COMPARISON_DATE } from '@shared/constants/Segmented.constants';
import { SEGMENTED_CONTEXT_NOTIFICATIONS } from '@shared/i18n/toastsNotificationsTexts';
import { METRIC_SEGMENTATION_MAPPING } from '@domain/_screens/overview/segmented/constants';

export const getSegmentedContextNotification = (metricsReport) => {
    const warning = metricsReport.data.warning.split('__');
    const secondPart = warning[1];
    return secondPart ? `${SEGMENTED_CONTEXT_NOTIFICATIONS[warning[0]] + secondPart}`
        : SEGMENTED_CONTEXT_NOTIFICATIONS[metricsReport.data.warning];
};

const alignDate = (firstData, secondData, metrics) => {
    if (firstData < secondData) {
        const difference = secondData - firstData;
        const emptyArray = Array(difference).fill({});
        return [...emptyArray, ...metrics];
    }
    return metrics;
};

const differenceInDaysOfWeek = (date = {}, comparisonDate = {}, metricsReport, segmentation) => {
    const firstDateFormatted = getDayOfWeek(stringToDate(date[segmentation]));
    const firstComparisonFormatted = getDayOfWeek(stringToDate(comparisonDate[segmentation]));

    return ({
        dateFormattedWithDifferenceInDays:
            alignDate(
                firstComparisonFormatted,
                firstDateFormatted,
                metricsReport.data.segmented,
            ),
        comparisonDateFormattedWithDifferenceInDays:
            alignDate(
                firstDateFormatted,
                firstComparisonFormatted,
                metricsReport.comparisonData.segmented,
            ),
    });
};

const formatMatchDataByDifference = (firstMetric, secondMetric) => {
    if (firstMetric.length < secondMetric.length) {
        const difference = secondMetric.length - firstMetric.length;
        const emptyArray = Array(difference).fill({});
        return [...firstMetric, ...emptyArray];
    }
    return firstMetric;
};


const matchData = (selectedMetric, comparisonMetric, metricForComparison) => (
    metricForComparison === PERIOD_COMPARISON_DATE.data
        ? formatMatchDataByDifference(selectedMetric, comparisonMetric)
        : formatMatchDataByDifference(comparisonMetric, selectedMetric)
);

const orderBySegmentation = (metrics, segmentation) => metrics.sort(
    (a, b) => stringToDate(a[segmentation]) - stringToDate(b[segmentation]),
);

export const getFormattedDataByDateOFWeek = (metricsReport, comparisonType, segmentation) => {
    const orderedData = orderBySegmentation(metricsReport.data.segmented, segmentation);

    const orderedComparisonData = orderBySegmentation(
        metricsReport.comparisonData.segmented, segmentation,
    );

    const { comparisonData, data } = PERIOD_COMPARISON_DATE;

    const expectedData = comparisonType === comparisonData ? comparisonData : data;

    if (segmentation !== METRIC_SEGMENTATION_MAPPING.Date) {
        return matchData(
            orderedData,
            orderedComparisonData,
            expectedData,
        );
    }

    const [firstDate] = orderedData;
    const [firstComparisonDate] = orderedComparisonData;

    const {
        dateFormattedWithDifferenceInDays,
        comparisonDateFormattedWithDifferenceInDays,
    } = differenceInDaysOfWeek(
        firstDate,
        firstComparisonDate,
        metricsReport,
        segmentation,
    );

    return matchData(
        dateFormattedWithDifferenceInDays,
        comparisonDateFormattedWithDifferenceInDays,
        expectedData,
    );
};
